<template>
  <div v-if="interestPoint">
    <nav>
      <section>
        <h4>{{interestPoint.translation.name}}</h4>
        <p>{{interestPoint.type}}</p>
      </section>
      <div class="share" @click="shareOpen = true">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
          <g fill="none" fill-rule="evenodd">
              <g>
                  <g>
                      <path d="M0 0H34V34H0z" transform="translate(-1316 -21) translate(1316 21)"/>
                      <path fill="#FFF" d="M24.969 20.188c-1.584 0-2.978.779-3.848 1.966l-7.537-3.768c.135-.441.229-.9.229-1.386 0-.486-.094-.945-.229-1.386l7.537-3.768c.87 1.187 2.264 1.966 3.848 1.966 2.64 0 4.781-2.14 4.781-4.78 0-2.641-2.14-4.782-4.781-4.782-2.64 0-4.782 2.14-4.782 4.781 0 .486.094.945.229 1.386l-7.537 3.768c-.87-1.187-2.264-1.966-3.848-1.966-2.64 0-4.781 2.14-4.781 4.781 0 2.64 2.14 4.781 4.781 4.781 1.584 0 2.978-.779 3.848-1.966l7.537 3.768c-.135.442-.229.901-.229 1.386 0 2.64 2.141 4.781 4.782 4.781 2.64 0 4.781-2.14 4.781-4.781 0-2.64-2.14-4.782-4.781-4.782zm0-14.344c1.758 0 3.187 1.43 3.187 3.187 0 1.758-1.43 3.188-3.187 3.188-1.758 0-3.188-1.43-3.188-3.188 0-1.758 1.43-3.187 3.188-3.187zM9.03 20.187c-1.758 0-3.187-1.429-3.187-3.187 0-1.758 1.43-3.188 3.187-3.188 1.758 0 3.188 1.43 3.188 3.188 0 1.758-1.43 3.188-3.188 3.188zm15.938 7.97c-1.758 0-3.188-1.43-3.188-3.188 0-1.758 1.43-3.188 3.188-3.188 1.758 0 3.187 1.43 3.187 3.188 0 1.758-1.43 3.187-3.187 3.187z" transform="translate(-1316 -21) translate(1316 21)"/>
                  </g>
              </g>
          </g>
        </svg>
      </div>
      <router-link to="/eventosActividade" class="close">
        <img src="@/assets/close.svg">
      </router-link>
    </nav>
    <section class="content">
      <section class="images-slider">
        <div class="images">
          <img :src="image.image_url" v-for="(image, index) in interestPoint.images" :key="image.id" :style="getPositionStyle(index)">
        </div>
        <div class="arrows">
          <img class="arrow-left" @click="moveImage('left')" src="@/assets/arrow-orange.svg">
          <img class="arrow-right" @click="moveImage('right')" src="@/assets/arrow-orange.svg">
        </div>
      </section>
      <section class="text-content-side">
        <h4>{{interestPoint.translation.name}}</h4>
        <p>{{interestPoint.translation.description}}</p>
        <div class="contacts">
          <h6>Contactos</h6>
          <p>{{interestPoint.address}}</p>
          <p>{{interestPoint.start_date}} - {{interestPoint.end_date}}</p>
          <p>{{interestPoint.translation.schedule}}</p>
        </div>
      </section>
    </section>
    <section class="circles-container">
      <div class="circles">
        <div class="circle" :class="{'active': currentImage === index}" @click="currentImage = index" v-for="(image, index) in interestPoint.images" :key="image.id">
        </div>
      </div>
    </section>
    <div id="map"></div>
    <share-tab :interestPoint="interestPoint" v-if="shareOpen" @close="shareOpen = false"></share-tab>
  </div>
</template>
<script>

let image = require('@/assets/interest_point_marker_clicked.png')
import shareTab from '../components/share-tab'
export default {
  name: 'pontoDeInteresse',
  props: ['id'],
  components: {
    shareTab
  },
  data() {
    return {
      interestPoint: null,
      currentImage: 0,
      shareOpen: false
    }
  },
  async mounted () {
    this.api.get('calendar/' + this.id + '/translated').then(point => {
      this.interestPoint = point
      setTimeout(() => this.loadMap(), 1)
    })
  },
  methods: {
    getPositionStyle (index) {
      if (index === 0) {
        return 'margin-left: -' + this.currentImage * 100 + '%'
      }
    },
    async loadMap () {
      try {
        var uluru = {lat: this.interestPoint.lat, lng: this.interestPoint.lng};
        let map = new google.maps.Map(document.getElementById('map'), {
          zoom: 17,
          center: uluru,
          disableDefaultUI: true,
          scrollwheel: false,
          draggable: false,
          styles: [
            {
              featureType: 'poi',
              stylers: [{visibility: 'off'}]
            },
            {
              featureType: 'transit',
              stylers: [{visibility: 'off'}]
            },
            {
              featureType: 'road',
              elementType: 'labels.text.fill',
              stylers: [{visibility: 'off'}]
            },
            {
              featureType: 'administrative',
              stylers: [{visibility: 'off'}]
            }
          ]
        })
        let point = new google.maps.LatLng(this.interestPoint.lat, this.interestPoint.lng)
        let marker = new google.maps.Marker({
          position: point,
          icon: image,
          map: map
        })
      } catch (error) {
        console.error(error);
      }
    },
    moveImage (direction) {
      let newPos = this.currentImage
      if (direction === 'left') newPos--;
      else newPos++

      let numImages = this.interestPoint.images.length
      if (newPos < 0) newPos =  numImages - 1
      else if (newPos > numImages - 1) newPos = 0

      this.currentImage = newPos
    }
  }
}
</script>
<style lang="scss" scoped>
#map {
  width: 70%;
  margin: 0 15%;
  min-height: 400px;
  margin-bottom: 80px;

    @media (max-width: 940px){
    margin: 0 10%;
    width: 80%;  
    margin-bottom: 80px;
  }

  @media (max-width: 767px){
    margin: 0 2.5%;
    width: 95%;  
    margin-bottom: 80px;
  }

  @media (max-width: 700px){
    margin: 0 16px;
    width: calc(100% - 32px);  
    margin-bottom: 80px;
  }
}
nav {
  height: 76px;
  background: #a79374;
  width: 100%;
  color: white;
  display: flex;
  align-items: center;
  h4 {
    font-size: 24px;
    font-weight: bold;
    margin-left: 40px;
  }
  p {
    font-weight: normal;
    font-size: 16px;
    margin-left: 40px;
    margin-top: 5px;
    flex-grow: 1;
  }
  .share {
    margin-left: auto;
    margin-right: 24px;
    cursor: pointer;
  }
  .close {
    margin-right: 32px;
    display: flex;
    align-items: center;
    img {
      display: block;
    }
  }

    @media (max-width: 700px){
    height: calc(132px - 24px - 24px);
    align-items: flex-start;
    padding: 24px 8px 24px 16px;
    width: calc(100% - 24px);

    h4 {
      margin-left: 0;
      margin-right: 16px;
    }

    p {
      margin-left: 0;
      margin-right: 16px;

    }
  }

  @media (max-width: 420px){ 
    h4 {
      font-size: 20px;
    }
  }
}
.content {
  margin: 60px 15% 0 15%;
  padding: 70px 0 20px 0;
  background: #f6ede0;
  display: flex;
  .images-slider {
    width: 50%;
    position: relative;
    .images {
      position: relative;
      display: flex;
      width: calc(100% - 120px);
      margin-left: 60px;
      height: 100%;
      overflow: hidden;
      img {
        position: relative;
        max-height: 100%;
        width: 100%;
        min-width: 100%;
        max-height: 400px;
        object-fit: cover;
        margin-left: 0%;
        transition: all 0.25s linear;
      }
    }
    .arrows {
      position: absolute;
      top: 50%;
      width: 100%;
      .arrow-left {
        position: absolute;
        left: 20px;
        transform: rotateZ(-180deg);
      }
      .arrow-right {
        position: absolute;
        right: 20px;
      }
      img {
        cursor: pointer;
      }
    }
  }
  .text-content-side {
    display: flex;
    flex-direction: column;
    width: 50%;
    & > * {
      margin-right: 20px;
    }
    h4 {
      font-size: 32px;
      font-weight: bold;
      color: #a79374;
      line-height: 1.25;
      letter-spacing: -0.73px;
    }
    .description {
      font-size: 18px;
      line-height: 1.56;
      letter-spacing: -0.4px;
    }
    .contacts {
      margin-top: auto;
      h6 {
        font-size: 18px;
        font-weight: bold;
        color: #a79374;
        margin-bottom: 10px;
      }
      p {
          line-height: 1.5;
      }
    }
  }

    @media (max-width: 940px){
    margin: 60px 10% 0 10%;  
  }

  @media (max-width: 767px){
    margin: 60px 2.5% 0 2.5%; 
    padding-top: 48px;
  }

  @media (max-width: 700px){
    flex-direction: column;
    margin: 24px 16px 0 16px;

    .images-slider {
      width: 100%;
    }
    .text-content-side {
      width: calc(100% - 32px);
      margin: 16px;
      h4 {
        font-size: 32px;
        margin-bottom: 8px;
        line-height: 1;
      }
      .contacts {
        margin-top: 24px;
      }
    }
  }
}
.circles-container {
  background: #f6ede0;
  margin: 0 15% 0 15%;
  .circles {
    padding: 0 0 20px 0;
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .circle {
      margin: 5px 10px;
      height: 10px;
      width: 10px;
      background: #f6b92f;
      border-radius: 50%;
      cursor: pointer;
      &.active {
        height: 24px;
        width: 24px;
      }
    }
  }

  @media (max-width: 940px){
    margin: 0 10% 0 10%;  
  }

  @media (max-width: 767px){
    display: none;
  }
}
.schedules-container {
  background: #eee3d4;
  margin: 0 15% 25px 15%;
  padding: 30px 60px 30px 60px;
  .schedules {
    display: flex;
    div {
      width: 50%;
      padding-right: 60px;
      h4 {
        font-size: 18px;
        font-weight: bold;
        color: #a79374;
        margin-bottom: 10px;
      }
      p {
        line-height: 1.5;
      }
    }
  }
  .schedules-extra {
    line-height: 1.5;
    color: #a79374;
    margin-top: 30px;
  }
}
</style>